module.exports = __webpack_public_path__ + "img/pr-1.94e57521.png";